export default __webpack_public_path__ + "static/media/view.09ce1f9f.svg";